<template>
    <component
        :is="component"
        class="limits-list__item"
        :class="{
            'is-active': active
        }"
        :value="limit.id"
    >
        <div v-if="$isClientApp && limit.preview" class="limits-list__logo">
            <img
                class="limits-list__image"
                :src="limit.preview"
                :alt="limitName"
                :title="limitName"
            />
        </div>
        <div v-else class="limits-list__name">
            {{ limitName }}
        </div>
        <div v-if="limit.name !== 'free'" class="limits-list__price">
            {{
                $t('upload.tariffPrice', {
                    price,
                    currency: currencySymbol
                })
            }}
        </div>
        <div v-else class="limits-list__price">
            FREE
        </div>
        <div class="limits-list__content">
            {{
                limit.params && limit.params.description && limit.params.description[$i18n.locale]
                    ? limit.params.description[$i18n.locale]
                    : ''
            }}
        </div>

        <div v-if="limit.name === 'free'" class="limits-list__warning" style="margin-top: 2px;">
            {{ $t('upload.freeTariff') }}
        </div>

        <slot name="limit-append" :limit="limit"></slot>
    </component>
</template>

<script>
import { RadioBox } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'LimitListCard',
    components: {
        RadioBox
    },
    props: {
        limit: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            default: false
        },
        selectable: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        component() {
            return this.selectable ? 'RadioBox' : 'li';
        },
        price() {
            let price = parseFloat(this.limit.price);
            if (this.limit.currency === 'USD') {
                price = (price * 1000) / 100;
            } else {
                price = price * 1000;
            }

            return price.toFixed(2).replace('.00', '');
        },
        currencySymbol() {
            return this.limit.currency === 'RUB' ? '₽' : '$';
        },
        limitName() {
            return (
                (this.limit.params.label && this.limit.params.label[this.$i18n.locale]) ||
                this.limit.label
            );
        }
    }
};
</script>
